
















































































import Vue from 'vue';
import { getUserProjects, deleteProject } from "@/api/Corporation";
import { Project } from '@/api/dto/Corporation';
import { UserProfile } from '@/api/dto/UserProfile';
import axios from "axios";
import { ErrorResponse } from "@/api/dto/Error";

interface Data {
  projects: Project[],
  setKeyword: string,
  deleteProjectConfirmModal: boolean,
  openDeleteProject: Project,
  isApiProcessing: boolean,
}


export default Vue.extend({
  name: 'Project',
  components: {
  },
  data(): Data {
    return {
      projects: [],
      setKeyword: '',
      deleteProjectConfirmModal: false,
      openDeleteProject: {} as Project,
      isApiProcessing: false,
    }
  },
  async beforeRouteEnter(to, from, next) {
    try {
      // 表示用情報取得
      const projects = await getUserProjects();
      next(vm => {
        (vm.$data as Data).projects = projects;
      });
    } catch (e) {
      // APIエラー
      next({ name: "Top" });
    }
  },
  computed: {
    filteredProject(): Project[] {
      if(this.setKeyword) { 
        return this.projects.filter(value =>  value.projectName?.includes(this.setKeyword));
      } else {
        return this.projects;
      }
    },
    isManagementUser(): boolean {
      let user = this.$store.getters.userProfile as UserProfile;
      return user.corporationsData.isManagementUser
    },
  },
  methods: {
    isProjectManager(managementUserId: string): boolean {
      let user = this.$store.getters.userProfile as UserProfile;
      if(managementUserId == user.id) {
        return true;
      } else {
        return false;
      }
    },
    popupOpen(project: Project) {
      const beforeActive = project.active;
      this.projects.map ( v => v.active = false);
      if (beforeActive) {
        project.active = false;
      } else {
        project.active = true;
      }
    },
    calcStatusMinWidth(item: Project): number {
      if (Number(item.totalMonthBudget) > Number(item.monthBudget)) {
        return 100
      } else {
        return Number(item.totalMonthBudget) / Number(item.monthBudget) *100
      }
    },
    onPushPath(project: Project, dealStatus: string) {
      this.$router.push({ name: "CorpProjectDetail", params: {projectId: project.id, dealStatus: dealStatus} });
    },
    /**
     * 依頼作成画面へ遷移
     */
    toDraft(projectName: string) {
      this.$router.push({ name: "CorpReviewDraft", params: { projectName: projectName } });
    },
    /**
     * プロジェクト編集へ遷移
     */
    toProjectEdit(project: Project) {
      this.$router.push({ name: "ProjectEdit", params: { projectId: project.id } });
    },
    /**
     * プロジェクト削除モーダルを開く
     */
    openDeleteProjectModal(project: Project) {
      this.openDeleteProject = project;
      this.deleteProjectConfirmModal = true;
    },
    /**
     * プロジェクト削除
     */
    async deleteProject() {
      try {
        this.isApiProcessing = true;
        await deleteProject(this.openDeleteProject.id)
        this.$emit('toast', 'プロジェクトを削除しました');
        // 再描画用のデータ取得
        this.projects = await getUserProjects();
      } catch (e) {
        if (axios.isAxiosError(e) && e.response) {
          var resError = e.response.data as ErrorResponse;
          this.$emit('errorToast', resError.message);
          return;
        } else {
          this.$emit('errorToast', 'プロジェクトの削除に失敗しました');
          return;
        }
      } finally {
        this.deleteProjectConfirmModal = false;
        this.isApiProcessing = false;
      }
    },
  },
})
